// Duotone (Phosphor) icons for visible surfaces, exported under the lucide names the app already uses.
// Tiny utility icons (close, chevrons, spinners, menu, +/−/check) stay as lucide thin lines for clarity.
import * as P from "@phosphor-icons/react";
export { X, ChevronDown, ChevronUp, ChevronRight, ChevronLeft, Loader2, Menu, Check, Plus, Minus, Info, AlertTriangle } from "lucide-react";

const duo = (I) => function DuoIcon(props) { return <I weight="duotone" {...props} />; };

export const Compass = duo(P.Compass);
export const LogOut = duo(P.SignOut);
export const CalendarCheck = duo(P.CalendarCheck);
export const LayoutGrid = duo(P.SquaresFour);
export const TrendingUp = duo(P.TrendUp);
export const TrendingDown = duo(P.TrendDown);
export const Gift = duo(P.Gift);
export const Heart = duo(P.Heart);
export const HeartPulse = duo(P.Heartbeat);
export const Sparkles = duo(P.Sparkle);
export const Trophy = duo(P.Trophy);
export const Flame = duo(P.Fire);
export const Star = duo(P.Star);
export const Bell = duo(P.Bell);
export const Flag = duo(P.Flag);
export const Wind = duo(P.Wind);
export const Settings2 = duo(P.Sliders);
export const Activity = duo(P.Pulse);
export const BookHeart = duo(P.BookBookmark);
export const BookOpen = duo(P.BookOpen);
export const Microscope = duo(P.Microscope);
export const Users = duo(P.Users);
export const Eye = duo(P.Eye);
export const EyeOff = duo(P.EyeSlash);
export const Mail = duo(P.Envelope);
export const Lock = duo(P.Lock);
export const HandHeart = duo(P.HandHeart);
export const MessageCircleHeart = duo(P.ChatCircleDots);
export const ShieldCheck = duo(P.ShieldCheck);
export const ShieldAlert = duo(P.ShieldWarning);
export const KeyRound = duo(P.Key);
export const Tags = duo(P.Tag);
export const Timer = duo(P.Timer);
export const Printer = duo(P.Printer);
export const Download = duo(P.DownloadSimple);
export const Share2 = duo(P.ShareNetwork);
export const Send = duo(P.PaperPlaneTilt);
export const Copy = duo(P.Copy);
export const Link2 = duo(P.Link);
export const Clock = duo(P.Clock);
export const Pencil = duo(P.PencilSimple);
export const Trash2 = duo(P.Trash);
export const CheckCircle2 = duo(P.CheckCircle);
export const Undo2 = duo(P.ArrowCounterClockwise);
export const RefreshCcw = duo(P.ArrowsClockwise);
export const ArrowUpRight = duo(P.ArrowUpRight);
export const ArrowDownRight = duo(P.ArrowDownRight);
export const UserMinus = duo(P.UserMinus);
export const ExternalLink = duo(P.ArrowSquareOut);
export const PartyPopper = duo(P.HandsClapping);
export const Megaphone = duo(P.Megaphone);
